import React from 'react';
import styled from 'styled-components';
import joint from '../../../assets/v2/Partner/joint.svg';
import hardwareOEMS from '../../../assets/v2/Partner/hardwareOEMS.svg';
import Lenovo from '../../../assets/v2/Partner/Lenovo.svg';
import zebra from '../../../assets/v2/Partner/zebra.svg';
import bluebird from '../../../assets/v2/Partner/bluebird.svg';
import Juniper from '../../../assets/v2/Partner/Juniper.svg';
import Khadas from '../../../assets/v2/Partner/Khadas.svg';
import Ruggear from '../../../assets/v2/Partner/ruggear.svg';

import amrel from '../../../assets/v2/Partner/amrel.png';
import pointmobile from '../../../assets/v2/Partner/pointmobile.png';
import honeywell from '../../../assets/v2/Partner/honeywell.png';
import posbank from '../../../assets/v2/Partner/posbank.png';
import posiflex from '../../../assets/v2/Partner/posiflex.png';
import samsung from '../../../assets/v2/Partner/samsung.png';
import shuttle from '../../../assets/v2/Partner/shuttle.png';
import siyata from '../../../assets/v2/Partner/siyata.png';
import teamsable from '../../../assets/v2/Partner/teamsable.png';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import { SectionParent, H1, H3 } from '../../StyledComponents';

const Section = styled(SectionParent)`
  display: grid;
  position: relative;
  justify-items: center;
  background-color: #fff;
  padding-bottom: 96px !important;
  padding-top: 96px !important;
  // max-width:800px;
`;
const SectionTitle = styled.div`
  // padding: 0;
  margin: 0 1rem;
  color: #1f2131;
  @media (max-width: 520px) {
    // text-align: center;
    width: 80%;
    // padding: 1rem 0;
    padding-bottom: 0;
  }

  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  // line-height: normal;
  letter-spacing: normal;
  text-align: left;
`;

const ImgWrapper = styled.div`
  display: grid;
  align-items: start;
  justify-items: center;
  //   padding-right: 1rem;
  grid-column: span 1;
  margin-bottom: 0.5rem;
  @media (max-width: 768px) {
    justify-items: center;
    margin-bottom: 0;
  }
`;
const GridTitle = styled.div`
  height: 48px;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  // line-height: 2.9;
  letter-spacing: normal;
  color: #151828;
  text-align: center;

  @media (max-width: 520px) {
    min-height: 1.5rem;
    line-height: normal;
    margin-top: 0.5rem;
  }
`;

const StyledImg = styled(LazyLoadImage)`
  height: 72px;
  @media (max-width: 520px) {
    height: 46px;
    margin: 10px;
  }
`;
const StyledImgBox = styled(LazyLoadImage)`
  width: 141px;
  height: 60px;
  border-radius: 4px;
  // box-shadow: 0 2px 6px 0 rgba(72, 82, 108, 0.15);
  background-color: #ffffff;
`;
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin-top: 2rem;
  margin-bottom: 1rem;
  grid-gap: 6rem 10rem;
  width: 90%;
  @media (max-width: 1920px) {
    grid-gap: 3rem 6rem;
  }

  @media (max-width: 1024px) {
    grid-gap: 4rem 8rem;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    margin-top: 2.5rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  border-radius: 5px;
`;

const GridItemContent = styled(H3)`
  font-family: 'Nunito Sans', sans-serif;
  margin-bottom: 2rem;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  // line-height: normal;
  letter-spacing: normal;
  color: #4f5263;
  text-align: left;
  @media (max-width: 768px) {
    padding-left: 10%;
    padding-right: 10%;
    text-align: center;
  }
  @media (max-width: 520px) {
    margin-bottom: 0;
  }
`;
const TitlesContainer = styled.div`
  padding-top: 0.5rem;
  @media (max-width: 768px) {
    text-align: center;
    padding-left: 0rem;
  }
`;
const TextWrapper = styled.div`
  display: grid;
  grid-column: span 2;
  @media (max-width: 768px) {
    // margin-left: -1rem;
  }
  @media (max-width: 350px) {
    margin-left: 0;
  }
`;
const InnerContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: 768px) {
    justify-items: center;
  }
`;

export default () => (
  <>
    <Section>
      <SectionTitle>
        <div style={{ display: 'grid', gridTemplateColumns: '3fr 10fr' }}>
          <div>
            <ImgWrapper>
              <StyledImg src={hardwareOEMS} />
            </ImgWrapper>
          </div>
          <div
            style={{ color: '#4f5263', fontSize: '16px', fontWeight: 'normal' }}
          >
            <p
              style={{ color: '#151828', fontSize: '20px', fontWeight: 'bold' }}
            >
              Android Hardware OEMs
            </p>
            Supporting custom Android devices builds.
          </div>
        </div>
      </SectionTitle>
      <GridContainer style={{ maxWidth: '920px' }}>
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox
                    style={{
                      padding: '8px',
                      boxShadow: '0 2px 6px 0 rgba(72, 82, 108, 0.15)',
                      height: '52px',
                      width: '134px',
                    }}
                    alt="Lenovo Esper Partner"
                    src={Lenovo}
                  />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox alt="Posbank Esper Partner" src={posbank} />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox alt="Zebra Esper Partner" src={zebra} />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox alt="Honeywell Esper Partner" src={honeywell} />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox alt="Bluebird Esper Partner" src={bluebird} />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox
                    alt="Pointmobile Esper Partner"
                    src={pointmobile}
                  />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox alt="Teamsable Esper Partner" src={teamsable} />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox alt="Siyata Esper Partner" src={siyata} />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox alt="Samsung Esper Partner" src={samsung} />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox alt="Juniper Esper Partner" src={Juniper} />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox alt="Posiflex Esper Partner" src={posiflex} />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox alt="Ruggear Esper Partner" src={Ruggear} />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox alt="Amrel Esper Partner" src={amrel} />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox alt="Shuttle Esper Partner" src={shuttle} />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>{' '}
        <GridItem>
          <InnerContainer>
            <TextWrapper>
              <TitlesContainer>
                <ImgWrapper>
                  <StyledImgBox alt="Khadas Esper Partner" src={Khadas} />
                </ImgWrapper>
              </TitlesContainer>
            </TextWrapper>
          </InnerContainer>
        </GridItem>
      </GridContainer>
    </Section>
  </>
);
